import { addToast } from '@octano/global-ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { Card } from 'reactstrap';

import { useLayoutState } from '../../../../hooks/useLayoutState';
import { PathsLayouts } from '../../../../config/routes';
import { Subsidy } from '../api/subsidy';
import { SubsidyForm } from './parts/SubsidyForm';

const SubsidyFormView = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams<{ id?: string }>();
  const { hideTabs, showTabs } = useLayoutState();
  const prefix = 'tariffAndTuition.subsidies';

  const recordToEdit: Subsidy | null = id
    ? ({ id: Number(id) } as Subsidy)
    : null;

  useEffect(() => {
    hideTabs();
    return () => {
      showTabs();
    };
  }, [hideTabs, showTabs]);

  const handleSubmit = (result: any) => {
    if (result.data) {
      addToast({
        icon: 'check',
        text: id ? t(`${prefix}.editChanges`) : t(`${prefix}.saveChanges`),
        color: 'success',
      });
      history.push(`${PathsLayouts.tariffAndTuiton}/subsidies`);
    } else {
      addToast({
        icon: 'error',
        text: t('common.errors.save'),
        color: 'danger',
      });
    }
  };

  const handleCancel = () => {
    history.push(`${PathsLayouts.tariffAndTuiton}/subsidies`);
  };

  return (
    <Card className="mx-3">
      <SubsidyForm
        recordToEdit={recordToEdit}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Card>
  );
};

export default SubsidyFormView;
